<div class="catalog-editor">
  <div class="editor-header">
    <button mat-button (click)="back()">
      <mat-icon>arrow_back</mat-icon> Volver
    </button>
    <span class="phone-chip" *ngIf="phone">Dueño: {{ phone }}</span>
  </div>

  <div class="loading-state" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    <p>Cargando catálogo...</p>
  </div>

  <mat-card class="tagus-card" *ngIf="!loading && draft">
    <mat-card-content>
      <mat-tab-group animationDuration="0ms">
        <!-- ─────────── 1. Diseño ─────────── -->
        <mat-tab label="Diseño">
          <div class="tab-body">
            <h5>Plantilla</h5>
            <mat-button-toggle-group [(ngModel)]="design.template">
              <mat-button-toggle
                *ngFor="let t of templates"
                [value]="t.value"
              >
                {{ t.label }}
              </mat-button-toggle>
            </mat-button-toggle-group>

            <h5 class="mt-20">Paleta</h5>
            <mat-radio-group [(ngModel)]="design.palette_type" class="radio-row">
              <mat-radio-button value="pastel">Pastel</mat-radio-button>
              <mat-radio-button value="vibrant">Vibrante</mat-radio-button>
            </mat-radio-group>

            <h5 class="mt-20">Color principal</h5>
            <div class="color-row">
              <p-colorPicker
                [(ngModel)]="design.color_primary"
                [inline]="false"
              ></p-colorPicker>
              <span
                class="color-swatch"
                [style.background]="design.color_primary"
              ></span>
              <span>{{ design.color_primary }}</span>
            </div>

            <div class="tab-actions">
              <button
                mat-flat-button
                class="default-btn bg-color-blue-button"
                (click)="saveDesign()"
                [disabled]="savingDesign"
              >
                {{ savingDesign ? "Guardando..." : "Guardar diseño" }}
              </button>
            </div>
          </div>
        </mat-tab>

        <!-- ─────────── 2. Negocio ─────────── -->
        <mat-tab label="Negocio">
          <div class="tab-body" [formGroup]="businessForm">
            <div class="form-grid">
              <mat-form-field appearance="outline">
                <mat-label>Nombre del negocio</mat-label>
                <input matInput formControlName="name" />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Teléfono</mat-label>
                <input matInput formControlName="phone" />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Dirección</mat-label>
                <input matInput formControlName="address" />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Instagram</mat-label>
                <input matInput formControlName="instagram" />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Facebook</mat-label>
                <input matInput formControlName="facebook" />
              </mat-form-field>
            </div>

            <h5 class="mt-10">Logo</h5>
            <div class="logo-row">
              <div class="logo-preview" *ngIf="logo">
                <img [src]="logo" alt="logo" />
                <button mat-icon-button (click)="removeLogo()">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <button
                mat-stroked-button
                (click)="logoInput.click()"
                [disabled]="uploadingLogo"
              >
                <mat-icon>image</mat-icon>
                {{ uploadingLogo ? "Subiendo..." : "Seleccionar logo" }}
              </button>
              <input
                #logoInput
                type="file"
                accept="image/*"
                hidden
                (change)="onLogoSelected($event)"
              />
            </div>

            <div class="tab-actions">
              <button
                mat-flat-button
                class="default-btn bg-color-blue-button"
                (click)="saveBusiness()"
                [disabled]="savingBusiness"
              >
                {{ savingBusiness ? "Guardando..." : "Guardar negocio" }}
              </button>
            </div>
          </div>
        </mat-tab>

        <!-- ─────────── 3. Productos ─────────── -->
        <mat-tab label="Productos ({{ products.length }})">
          <div class="tab-body">
            <div class="products-toolbar">
              <button
                mat-flat-button
                class="default-btn bg-color-blue-button"
                (click)="addProduct()"
                [disabled]="!canAddProduct"
              >
                <mat-icon>add</mat-icon> Agregar producto
              </button>
              <span class="hint">Máx. {{ maxProducts }} productos</span>
            </div>

            <div
              class="tagus-mat-table mat-elevation-z8"
              *ngIf="products.length > 0; else noProducts"
            >
              <table mat-table [dataSource]="products" class="table-responsive">
                <ng-container matColumnDef="image">
                  <th mat-header-cell *matHeaderCellDef>Imagen</th>
                  <td mat-cell *matCellDef="let el">
                    <img
                      *ngIf="el.images && el.images.length"
                      [src]="el.images[0]"
                      class="row-thumb"
                      alt="producto"
                    />
                    <mat-icon *ngIf="!el.images || !el.images.length" class="muted">
                      image_not_supported
                    </mat-icon>
                  </td>
                </ng-container>

                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Nombre</th>
                  <td mat-cell *matCellDef="let el">{{ el.name }}</td>
                </ng-container>

                <ng-container matColumnDef="price">
                  <th mat-header-cell *matHeaderCellDef>Precio</th>
                  <td mat-cell *matCellDef="let el">{{ el.price || "—" }}</td>
                </ng-container>

                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef>Descripción</th>
                  <td mat-cell *matCellDef="let el" class="desc-cell">
                    {{ el.description || "—" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>Acciones</th>
                  <td mat-cell *matCellDef="let el; let i = index">
                    <button
                      mat-icon-button
                      class="blue-color"
                      matTooltip="Editar"
                      (click)="editProduct(i)"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      class="blue-color"
                      matTooltip="Eliminar"
                      (click)="deleteProduct(i)"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="productColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: productColumns"></tr>
              </table>
            </div>

            <ng-template #noProducts>
              <div class="no-results">
                <mat-icon>inventory_2</mat-icon>
                <p>Aún no hay productos.</p>
              </div>
            </ng-template>
          </div>
        </mat-tab>

        <!-- ─────────── 4. Revisar y generar ─────────── -->
        <mat-tab label="Revisar y generar">
          <div class="tab-body">
            <div class="review-actions">
              <button mat-stroked-button (click)="validate()">
                <mat-icon>fact_check</mat-icon> Validar
              </button>
              <button mat-stroked-button (click)="preview()">
                <mat-icon>visibility</mat-icon> Vista previa
              </button>
              <button
                mat-flat-button
                class="default-btn bg-color-blue-button"
                (click)="generate()"
                [disabled]="generating"
              >
                <mat-icon>picture_as_pdf</mat-icon>
                {{ generating ? "Generando..." : "Generar PDF" }}
              </button>
            </div>

            <mat-progress-bar
              *ngIf="generating"
              mode="indeterminate"
              class="mt-10"
            ></mat-progress-bar>

            <div class="validation-box" *ngIf="validation">
              <p class="valid-line" [class.ok]="validation.isValid">
                <mat-icon>{{
                  validation.isValid ? "check_circle" : "cancel"
                }}</mat-icon>
                {{
                  validation.isValid
                    ? "El catálogo está listo para generar"
                    : "Corrige los errores antes de generar"
                }}
              </p>
              <ul class="errors" *ngIf="validation.errors.length">
                <li *ngFor="let e of validation.errors">{{ e }}</li>
              </ul>
              <ul class="warnings" *ngIf="validation.warnings.length">
                <li *ngFor="let w of validation.warnings">{{ w }}</li>
              </ul>
            </div>

            <div class="pdf-ready" *ngIf="draft && draft.catalog_pdf_url as pdfUrl">
              <mat-icon>task_alt</mat-icon>
              <span>PDF disponible</span>
              <button mat-button class="blue-color" (click)="openPdf(pdfUrl)">
                Descargar
              </button>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>
